// @flow
// DUPLICATE restApi.ts

declare class AbortSignal extends EventTarget {
    +aborted: boolean;
    onabort: EventHandler;
}

declare class AbortController {
    +signal: AbortSignal;
    abort: () => void;
}

export type AbortControllerType = typeof AbortController;
export type RequestHeaders = { [key: string]: string };

/** REST API abstraction */
export interface ApiClient {
    get(path: string, params?: any, headers?: RequestHeaders): Promise<any>;
    post(path: string, body: any, headers?: RequestHeaders): Promise<any>;
    put(path: string, body: any, headers?: RequestHeaders): Promise<any>;
    delete(path: string, params?: any, headers?: RequestHeaders): Promise<any>;
    abort(): void | typeof undefined;
    setRequestHeader(key: string, val: string | null): void;
}

export const COMMON_HEADERS = {
    "Cache-Control": "no-cache",
    "X-Server-Select": "frontend",
};
